export default {
    administratorFormData(state) {
        return {
            email: state.administratorDetails ? state.administratorDetails.email : '',
            phoneNumber: state.administratorDetails ? state.administratorDetails.phoneNumber : '',
            enabled: state.administratorDetails ? state.administratorDetails.enabled : false,
            locked: state.administratorDetails ? state.administratorDetails.locked : false,
            clock24Hours: state.administratorDetails ? state.administratorDetails.profile.clock24Hours : false,
            locale: state.administratorDetails ? state.administratorDetails.profile.locale : '',
            tenantId: state.administratorDetails ? state.administratorDetails.tenantId : '',
            timezone: state.administratorDetails ? state.administratorDetails.profile.timezone : '',
            dateFormat: state.administratorDetails ? state.administratorDetails.profile.dateFormat : '',
        }
    },
    administratorPasswordForm() {
        return {
            plainPassword: '',
            repeatedPassword: ''
        }
    },
    createFilterQuery(query) {
        let filter = '';

        Object.keys(query).forEach(key => {
            filter += query[key];

            if (key === 'email') {
                filter += '&filters[email][0][operator]=like'
            }
        });

        return filter;
    }
}
